import { render, staticRenderFns } from "./ConfirmationDialogActivityForumThread.vue?vue&type=template&id=9a835056"
import script from "./ConfirmationDialogActivityForumThread.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogActivityForumThread.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialogActivityForumThread.vue?vue&type=style&index=0&id=9a835056&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports